//import { DatosPrueba } from "./search.state";

import { TagsItem } from 'src/app/interfaces/tagsItems';

//OK
export class UpDateSearchState {
  static readonly type = '[Home-Component] Up Date SearchState';
  constructor(public slugInstitucion: string, public categorias: string [] ) {}                            
}
export class LoadTagsSearch {
  static readonly type = '[Tags-Select]  Load Tags';
  constructor(public categoria: string, public limite: number) {}
}

export class AddTagSearch {
  static readonly type = '[Tags-Select] Add Tag';
  constructor(public tag: TagsItem, public categoria: string, public limite: number) {}
}

export class RemoveTagSearch{
  static readonly type = '[Tags-Select] Remove Tag';
  constructor(public tag: TagsItem, public categoria: string) {}
}


//OK
export class SearchTags {
  static readonly type = '[Tags-Select] Search Tags';
  constructor(
    public value: string,
    public categoria: string,
    public limite: number
  ) {}
}
export class Buscar {
  static readonly type = '[Busqueda] Buscar';
  constructor() {}
}


                            //   NORMALES   //
export class LoadTagsNormales {
  static readonly type = '[Tags-Select]  Load Tags Normales';
  constructor(public categoria: string, public limite: number) {}
}
export class AddTagNormales {
  static readonly type = '[Tags-Select] Add Tag Normales';
  constructor(public tag: TagsItem, public categoria: string, public limite: number) {}
}
export class RemoveTagNormales {
  static readonly type = '[Tags-Select] Remove Tag Normales';
  constructor(public tag: TagsItem, public categoria: string) {}
}



                            //   SEARCH   //

export class LoadTagsPlanes {
  static readonly type = '[Tags-Select]  Load Tags Planes';
  constructor(public categoria: string, public limite: number) {}
}

export class AddTagPlanes {
  static readonly type = '[Tags-Select] Add Tag Planes';
  constructor(public tag: TagsItem, public categoria: string, public limite: number) {}
}

export class RemoveTagPlanes {
  static readonly type = '[Tags-Select] Remove Tag Planes';
  constructor(public tag: TagsItem, public categoria: string) {}
}
                           //   Localidades   //


export class LoadTagsLocalidades {
  static readonly type = '[Tags-Select] Load Tag Localidades';
  constructor(public categoria: string, public limite: number) {}
}

export class AddTagsLocalidades {
  static readonly type = '[Tags-Select] Add Tag Localidades';
  constructor(public tag: TagsItem, public categoria: string, public limite: number) {}
}


export class RemoveTagsLocalidades {
  static readonly type = '[Tags-Select] Remove Tag Localidades';
  constructor(public tag: TagsItem, public categoria: string) {}
}